import "../../utils/tailwind.css";
import { PageProvider, useBlogsProvider } from "./provider";
import Label from "../../components/label";
import Section from "../../components/section";
import Trash from "../../components/svg/trash";
import TableLoader from "../../components/table-loader";
import Button from "../../components/Buttons";
import { FieldArray, Form, Formik } from "formik";
import { FormikInput } from "../../components/input";
import { Accordion } from "react-bootstrap";
import { FormikDropdown } from "../../components/dropdown";
import { FormikTextarea } from "../../components/textarea";
import Plus from "../../components/svg/plus";
import { FormikSwitch } from "../../components/switch";

export default function AddUser() {
  return (
    <div className="p-3">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const {
    getPlansQuery,
    initialValues,
    handleSubmit,
   
    monialsRef,
    getFaqQuery,
  
    dynamicAccordions,
    deleteDynamicAccordion,
    setDynamicAccordions,
  } = useBlogsProvider();

  if (getPlansQuery?.isPending) {
    return <TableLoader />;
  }

  return (
    <Section>
      <Formik initialValues={initialValues} enableReinitialize onSubmit={handleSubmit}>
        {({ values, setFieldValue }) => (
          <Form>
            <Accordion defaultActiveKey="0" className="mt-5">
              <Accordion.Item eventKey="1">
                <Accordion.Header>SEO Meta</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                    <div className="flex flex-col">
                      <Label label="Meta Title" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="meta_seo.meta_title" rootClassName="w-full" />
                    </div>

                    <div className="flex flex-col">
                      <Label label="Meta Keywords" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="meta_seo.meta_keyword" rootClassName="w-full" as="textarea" className="h-[26rem]" />
                    </div>
                    <div className="flex flex-col ">
                      <Label label="Meta Description" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="meta_seo.meta_desc" rootClassName="w-full" as="textarea" className="h-[26rem]" />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="2">
                <Accordion.Header>Banner</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <div className="flex flex-col">
                      <Label label="Primary Heading" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="header.primary_heading" rootClassName="w-full" />
                    </div>

                    <div className="flex flex-col">
                      <Label label="Secondery Heading" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="header.secondary_heading" rootClassName="w-full" />
                    </div>
                  </div>

                  <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-3 mt-3">
                    <div className="flex flex-col">
                      <Label label="CTA" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="header.primary_cta.label" rootClassName="w-full" />
                    </div>
                    <div className="flex flex-col">
                      <Label label="CTA Redirect Link" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="header.primary_cta.redirect_link" rootClassName="w-full" />
                    </div>

                    <div className="flex flex-col">
                      <Label label="CTA" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="header.secondary_cta.label" rootClassName="w-full" />
                    </div>
                    <div className="flex flex-col">
                      <Label label="CTA Redirect Link" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="header.secondary_cta.redirect_link" rootClassName="w-full" />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 mt-3 gap-3">
                    <div className="flex flex-col">
                      <Label label="Description" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikTextarea name="header.description" rootClassName="w-full" as="textarea" />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="9">
                <Accordion.Header>Compare Plans and Features</Accordion.Header>

                <Accordion.Body>
                  <div className="grid grid-cols-1 sm:grid-cols-1  gap-3">
                    <div className="flex flex-col">
                      <Label label="Heading" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="compare_plans.heading" rootClassName="w-full" />
                    </div>
                  </div>

                  <div className="flex justify-end my-2">
                    <div
                      className=" cursor-pointer"
                      onClick={() => {
                        setFieldValue("dynamic_sections", [...values.dynamic_sections, { heading: "", table: [] }]);
                        setDynamicAccordions((prev) => [...prev, { key: prev.length, name: `custom_section_${prev.length + 1}` }]);
                      }}
                    >
                      <Button className="!font-normal !text-[12px]">Add New Section</Button>
                    </div>
                  </div>


                  {dynamicAccordions.map((section, idx) => (
                    <Accordion key={section.key} className="mt-2">
                      <Accordion.Item eventKey={section.key.toString()}>
                        <Accordion.Header>
                          {values.dynamic_sections?.[idx]?.heading?.trim() ? values.dynamic_sections[idx].heading : `Custom Section ${idx + 1}`}
                        </Accordion.Header>

                        <Accordion.Body>
                          <div className="flex justify-end">
                            <div
                              title="Delete Section"
                              onClick={() => {
                                deleteDynamicAccordion(section.key);
                                setFieldValue(
                                  "dynamic_sections",
                                  values.dynamic_sections.filter((_, i) => i !== idx),
                                );
                              }}
                            >
                              <Button className="!font-normal  !text-[13px]">Delete Section</Button>
                            </div>
                          </div>
                          <div>
                            <Label label="Heading" className="mb-2 text-black text-[15px] font-semibold" />
                            <FormikInput name={`dynamic_sections.${idx}.heading`} rootClassName="w-full" />
                          </div>

                          <FieldArray name={`dynamic_sections.${idx}.table`}>
                            {(arrayHelpers) => (
                              <div className="mt-2 overflow-x-auto">
                                <div className="flex justify-end mt-3 mb-2">
                                  <div
                                    className="bg-[#7C13CA] w-6 h-6 flex mt-2 items-center justify-center rounded-full cursor-pointer mr-2"
                                    onClick={() =>
                                      arrayHelpers.push({
                                        title: "",
                                        col1: "",
                                        col2: "",
                                        col3: "",
                                        // col4: "",
                                      })
                                    }
                                  >
                                    <Plus className="text-white w-4 h-4" />
                                  </div>
                                </div>

                                <table className="w-full table-fixed border-collapse border border-gray-300">
                                  <thead className="bg-gray-200">
                                    <tr>
                                      <th className="w-[18.8%] border font-normal border-gray-300 px-2 py-2 text-left">Title</th>

                                      <th className="w-[18.8%] border font-normal border-gray-300 px-2 py-2 text-left">
                                        <div className="flex items-center justify-between gap-2">
                                          <span>Column 1</span>
                                          <FormikSwitch name={`dynamic_sections.${idx}.is_publish_col.col1`} />
                                        </div>
                                      </th>

                                      <th className="w-[18.8%] border font-normal border-gray-300 px-2 py-2 text-left">
                                        <div className="flex items-center justify-between">
                                          <span>Column 2</span>
                                          <FormikSwitch name={`dynamic_sections.${idx}.is_publish_col.col2`} />
                                        </div>
                                      </th>

                                      <th className="w-[18.8%] border font-normal border-gray-300 px-2 py-2 text-left">
                                        <div className="flex items-center justify-between gap-2">
                                          <span>Column 3</span>
                                          <FormikSwitch name={`dynamic_sections.${idx}.is_publish_col.col3`} />
                                        </div>
                                      </th>

                                      <th className="w-[6%] border font-normal border-gray-300 px-2 py-2 text-center">Action</th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    {values.dynamic_sections?.[idx]?.table?.map((_, rowIdx) => (
                                      <tr key={rowIdx}>
                                        <td className="border border-gray-300 px-2 py-2">
                                          <FormikInput name={`dynamic_sections.${idx}.table.${rowIdx}.title`} rootClassName="w-full" />
                                        </td>
                                        <td className="border border-gray-300 px-2 py-2">
                                          <FormikInput name={`dynamic_sections.${idx}.table.${rowIdx}.col1`} rootClassName="w-full" />
                                        </td>
                                        <td className="border border-gray-300 px-2 py-2">
                                          <FormikInput name={`dynamic_sections.${idx}.table.${rowIdx}.col2`} rootClassName="w-full" />
                                        </td>
                                        <td className="border border-gray-300 px-2 py-2">
                                          <FormikInput name={`dynamic_sections.${idx}.table.${rowIdx}.col3`} rootClassName="w-full" />
                                        </td>
                                        {/* <td className="border border-gray-300 px-2 py-2">
                                          <FormikInput name={`dynamic_sections.${idx}.table.${rowIdx}.col4`} rootClassName="w-full" />
                                        </td> */}
                                        <td className="border border-gray-300 px-2 py-2 text-center">
                                          <div className="flex justify-center cursor-pointer" onClick={() => arrayHelpers.remove(rowIdx)}>
                                            <Trash />
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </FieldArray>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  ))}
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="8" className="mb-8">
                <Accordion.Header>FAQ's</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-1 sm:grid-cols-1 gap-3">
                    <div className="flex flex-col">
                      <Label label="FAQ Heading" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="testimonials.heading" rootClassName="w-full" />
                    </div>
                  </div>
                  <div className="flex justify-end mt-3">
                    <div className="bg-[#7C13CA] p-1 rounded-full w-auto cursor-pointer" onClick={() => monialsRef?.current?.push({ faq: "" })}>
                      <Plus className="text-white" />
                    </div>
                  </div>

                  <FieldArray name="testimonials.testimonials">
                    {(arrayHelpers) => {
                      monialsRef.current = arrayHelpers;

                      return (
                        <div className="mt-2 overflow-x-auto">
                          <table className="w-full table-fixed border-collapse border border-gray-300">
                            <thead className="bg-gray-200">
                              <tr>
                                <th className="w-[94%] border font-normal border-gray-300 px-2 py-2 text-left">Faq</th>
                                <th className="w-[6%] border font-normal border-gray-300 px-2 py-2 text-center">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {values?.testimonials?.testimonials?.map((item, index) => (
                                <tr key={index}>
                                  <td className="border border-gray-300 px-4 py-2">
                                    <FormikDropdown
                                      options={getFaqQuery?.data?.data?.data?.map((item) => ({
                                        label: item.ques,
                                        value: item.id,
                                      }))}
                                      name={`testimonials.testimonials.${index}.faq`}
                                      rootClassName="w-full"
                                    />
                                  </td>
                                  <td className="border border-gray-300 px-4 py-2 text-center">
                                    <div className="flex justify-center cursor-pointer" onClick={() => monialsRef?.current?.remove(index)}>
                                      <Trash />
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      );
                    }}
                  </FieldArray>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

            <div className="fixed bottom-0 z-[999] left-0 w-full bg-[#fef5e4] flex justify-end items-center py-3 rounded-lg pr-4 space-x-3 shadow-md">
              <Button
                type="submit"
                className="!border-none text-white rounded-md !bg-[#7C13CA] hover:!bg-[#ffd869] hover:!text-black transition-colors duration-200"
              >
                Save
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </Section>
  );
}
